import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/stat-callcenter/StatCallCenter.vue'),
		meta: {
			title: 'stat-callcenter',
			acl: 'section.stat-callcenter'
		}
	}
];

export default routes;